"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _times = require("HubStyleTokens/times");

var _TwoWayTransition = _interopRequireDefault(require("../../transitions/TwoWayTransition"));

var _ModalTransitionContext = require("../../context/ModalTransitionContext");

var _overlayTransitionMixin = require("./overlayTransitionMixin");

var _UIDialog = _interopRequireDefault(require("../UIDialog"));

var totalTransitionTime = parseInt(_times.DEFAULT_MODAL_TRANSITION_TIMING, 10);
var overlayTransitionTime = parseInt(_times.MODAL_BACKGROUND_TRANSITION_TIMING, 10);
var dialogTransitionTime = totalTransitionTime - overlayTransitionTime;
var overlayTransition = (0, _overlayTransitionMixin.getOverlayTransition)(dialogTransitionTime);
var ModalTransitionWrapper = (0, _styledComponents.default)(_TwoWayTransition.default.PlainWrapper).withConfig({
  displayName: "ModalTransition__ModalTransitionWrapper",
  componentId: "cg6peb-0"
})(["", "{transition-property:", ";transition-delay:", "ms;transition-duration:", "ms;opacity:", ";transform:", ";}", ";"], _UIDialog.default.Selector, function (_ref) {
  var transitionActive = _ref.transitionActive;
  return transitionActive ? 'opacity, transform' : 'none';
}, overlayTransitionTime, dialogTransitionTime, function (_ref2) {
  var open = _ref2.open;
  return open ? '1' : '0';
}, function (_ref3) {
  var open = _ref3.open;
  return "scale(" + (open ? '1' : '0.9') + ")";
}, overlayTransition);

var ModalTransition = function ModalTransition(props) {
  return _react.default.createElement(_TwoWayTransition.default, Object.assign({}, props, {
    ContextProvider: _ModalTransitionContext.ModalTransitionContextProvider,
    duration: totalTransitionTime,
    transitionOnMount: true,
    Wrapper: ModalTransitionWrapper
  }));
};

ModalTransition.displayName = 'ModalTransition';
var _default = ModalTransition;
exports.default = _default;
module.exports = exports.default;